<header>
    <mat-toolbar role="heading" aria-level="1" color="primary" class="backoffice--header">
        <picture>
            <source srcset="/assets/img/sympheny-new-logo.webp" width="250" type="image/webp" />
            <source srcset="/assets/img/sympheny-new-logo.png" width="250" type="image/png" />
            <img class="logo-element" width="250" src="/assets/sympheny-new-logo.webp" alt="Sympheny Logo" />
        </picture>
    </mat-toolbar>
</header>
